import { z } from 'zod';

/**
 * Codes d'erreur de l'API (`api.md` § Conventions). Seule source de vérité côté serveur
 * (`AppError`) et côté client (`ApiError`). T06 complète la liste si des codes manquent.
 */
export const ErrorCode = z.enum([
  'validation_error',
  'unauthenticated',
  'forbidden',
  'bad_origin',
  'not_found',
  'conflict',
  'scan_already_running',
  'invalid_transition',
  'experiment_locked',
  'experiment_already_active',
  'opportunity_not_shortlisted',
  'invitation_invalid',
  'invitation_pending',
  'user_exists',
  'last_admin',
  'rule_violation',
  'rate_limited',
  /** Dépense du mois + estimation > plafond mensuel (`402`, actions payantes hors scan). */
  'budget_exceeded',
  /** Analyse de site (`422`) : hôte injoignable, erreur HTTP, délai, réponse non HTML. */
  'site_unreachable',
  /** Analyse de site (`422`) : 403/429/503 ou page anti-bot. */
  'site_blocked',
  /** Analyse de site (`422`) : presque aucun texte visible (rendu JavaScript probable). */
  'site_empty',
  'config_error',
  'provider_error',
  'internal_error',
]);
export type ErrorCode = z.infer<typeof ErrorCode>;

/** Corps d'une réponse d'erreur : `{ error: { code, message, details?, requestId? } }`. */
export const ApiErrorBody = z.object({
  error: z.object({
    code: ErrorCode,
    message: z.string(),
    details: z.unknown().optional(),
    requestId: z.string().optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBody>;
